
import type { ContentType, TableConfig, CommentRow } from './types';
import type { Comment } from '@/types/social';

/**
 * Returns the appropriate table name and ID field name based on content type
 */
export const getTableConfig = (contentType: ContentType): TableConfig => {
  return contentType === 'poll' 
    ? { tableName: 'poll_comments', idField: 'poll_id' }
    : { tableName: 'card_comments', idField: 'card_id' };
};

/**
 * Converts a database row to a Comment object
 */
export const mapRowToComment = (row: any, contentType: ContentType, contentId: string): Comment => {
  const { idField } = getTableConfig(contentType);
  
  return {
    id: row.id,
    card_id: contentType === 'card' ? contentId : undefined,
    poll_id: contentType === 'poll' ? contentId : undefined,
    user_id: row.user_id,
    anonymous_id: row.anonymous_id,
    parent_id: row.parent_id,
    content: row.content,
    created_at: row.created_at,
    updated_at: row.updated_at,
    deleted: row.deleted,
    reported: row.reported,
    user_name: row.user_id ? (row.profiles?.name || 'User') : 'Anonymous User',
    replies: [],
    likes_count: 0
  };
};

/**
 * Type guard to check if a row is a CardCommentRow
 */
export const isCardCommentRow = (row: any): boolean => {
  return 'card_id' in row;
};

/**
 * Type guard to check if a row is a PollCommentRow
 */
export const isPollCommentRow = (row: any): boolean => {
  return 'poll_id' in row;
};
